var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loaderContainer"},[(_vm.loader)?_c('div',{staticClass:"loader",style:({'width': _vm.loader + '%'})}):_c('div',{staticClass:"notLoader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }